import React, { useEffect, useState } from 'react';

import styles from './index.module.scss';

interface StepProps {
  children: React.ReactNode;
}

const Step: React.FC<StepProps> = ({ children }) => {
  return (
    <div className={styles.step}>
      <div className={styles.stepContent}>
        {children}
      </div>
    </div>
  );
};

export default Step; 